<template>
    <div id="search-components">
        <section class="search-wrap">
            <!-- 搜索短期项目 -->
            <ul>
                <li><input type="text" placeholder="搜索您想要学习的美食" v-model.trim="searchText"></li>
                <li><a href="javascript:void(0)" @click.self="handerSearch">搜索</a></li>
            </ul>
        </section>
        <!-- 搜索结果 -->
        <searchResult :postText="postSearchText"></searchResult>
    </div>
</template>

<script>
import searchResult from '@/components/Search/SearchResult'
export default {
    data(){
        return {
            searchText:'',  // 输入搜索内容
            postSearchText: null // 传递搜索内容到子组件
        }
    },
    components: {
        searchResult
    },
    methods: {
        handerSearch(){
            this.postSearchText = this.searchText;
             this.$emit('mysearch',this.postSearchText);
        }
    },
    watch:{
        handerSearch(){ // 监听是否点击搜索按钮，并且传递搜索的内容过去
            this.$emit('mysearch',this.postSearchText);
        }
    }
}
</script>

<style lang="less" scoped>
// 初始化设计图尺寸 注意：less 除法要用小括号括起来
@rem: 40rem;
@w100: (640/@rem);
.justify {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
}
.auto(@w) {
    width: (@w/@rem);
    margin: 0 auto;
}
// 圆角
.radius(@radius) {
    border-radius: (@radius/@rem) (@radius/@rem) (@radius/@rem) (@radius/@rem);
}
.linefont(@lineHeight, @fontSize, @color) {
    line-height: (@lineHeight/@rem);
    font-size: (@fontSize/@rem);
    color: @color;
}
.backgroundUrl(@img) {
    background: url(@img) no-repeat center / contain;
}
.aimg(@h) {
    a {
        display: block;
        img {
            width: 100%;
            height: (@h/@rem);
        }
    }
}
// vue闪烁问题
[v-cloak] {
    display: none;
}
// 搜索短期项目
.search-wrap {
    padding: (20/@rem) 0;
    background: #ffd5d5;
    ul {
        .auto(610);
        &:extend(.justify);

        li {
            &:first-child {
                width: (480/@rem);
                border: 1px solid #7d7d7d;
                background: #ffffff;
                .radius(25);
                position: relative;

                input {
                    width: 80%;
                    .linefont(46, 18, #686262);
                }

                &:before {
                    content: '';
                    display: block;
                    width: (25/@rem);
                    height: (25/@rem);
                    .backgroundUrl('/assets/img/home/ixion/search-icon.png');
                    position: absolute;
                    top: 50%;
                    left: (13/@rem);
                    transform: translateY(-50%);
                }
            }

            &:last-child {
                a {
                    display: block;
                    width: (123/@rem);
                    .linefont(48, 22, #fff);
                    background: #d83538;
                    .radius(25);
                }
            }
        }
    }
}
</style>